'use client';

import { SupportChatLayout } from '@/components/support/SupportChatLayout';
import { motion } from 'framer-motion';

export default function SupportPage() {
  return (
    <div className="h-[calc(100vh-7.5rem)] min-h-[580px] flex flex-col">
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-4 flex-shrink-0"
      >
        <h1 className="text-2xl sm:text-3xl font-bold text-nature-text">Support & Help</h1>
        <p className="text-nature-muted text-xs sm:text-sm mt-0.5">
          Chat directly with the EnthiosHub admin team for assistance with your organization, account, or events.
        </p>
      </motion.div>

      <div className="flex-1 min-h-0 flex flex-col">
        <SupportChatLayout mode="organizer" />
      </div>
    </div>
  );
}
